import type { FormParams } from '@/app/types';
import { MODEL_VERSION, TASK_TRANSITION_PRO_AD } from './form-settings-config';

export const DEFAULT_SCENE_MAX_IMAGE_COUNT = 1;
export const ONE_CLICK_MV_V2_MAX_IMAGE_COUNT = 6;

// 默认表单参数
export const DEFAULT_FORM_PARAMS: FormParams = {
  imagePrompts: [],
  textPrompt: '',
  isProMode: false,
  modelVersion: MODEL_VERSION.Q3,
  settingsV2_0: {
    style: 'general',
    duration: 4,
    resolution: '512',
    movement_amplitude: 'auto',
    aspect_ratio: '16:9',
    sample_count: 1,
    schedule_mode: 'normal',
    codec: 'h265',
  },
  settingsQ1: {
    style: 'general',
    duration: 5,
    resolution: '1080p',
    movement_amplitude: 'auto',
    aspect_ratio: '16:9',
    sample_count: 1,
    schedule_mode: 'normal',
    transition: 'creative',
    codec: 'h265',
  },
  settingsQ2: {
    duration: 5,
    resolution: '1080p',
    movement_amplitude: 'auto',
    aspect_ratio: '16:9',
    sample_count: 1,
    schedule_mode: 'normal',
    transition: 'speed',
    codec: 'h265',
  },
  settingsQ2_pro: {
    duration: 5,
    resolution: '1080p',
    movement_amplitude: 'auto',
    aspect_ratio: '16:9',
    sample_count: 1,
    schedule_mode: 'normal',
    codec: 'h265',
  },
  settingsQ3: {
    duration: 8,
    resolution: '1080p',
    movement_amplitude: 'auto',
    aspect_ratio: '16:9',
    sample_count: 1,
    schedule_mode: 'normal',
    transition: 'pro',
    codec: 'h265',
  },
  settingsQ3_pro: {
    duration: 0,
    resolution: '1080p',
    aspect_ratio: '16:9',
    sample_count: 1,
    movement_amplitude: 'auto',
    schedule_mode: 'normal',
  },
  settingsQ3_fast: {
    duration: 0,
    resolution: '1080p',
    aspect_ratio: '16:9',
    sample_count: 1,
    movement_amplitude: 'auto',
    schedule_mode: 'normal',
  },
  settingsQ3_lite: {
    duration: 0,
    resolution: '1080p',
    aspect_ratio: '16:9',
    sample_count: 1,
    movement_amplitude: 'auto',
    schedule_mode: 'normal',
  },
  settingsGPTImage2: {
    duration: 0,
    resolution: '1080p',
    aspect_ratio: '16:9',
    sample_count: 1,
    movement_amplitude: 'auto',
    schedule_mode: 'normal',
  },
  settingsGPTImage25Fast: {
    duration: 0,
    resolution: '1080p',
    aspect_ratio: '16:9',
    sample_count: 1,
    movement_amplitude: 'auto',
    schedule_mode: 'normal',
  },
  settingsGPTImage25Pro: {
    duration: 0,
    resolution: '1080p',
    aspect_ratio: '16:9',
    sample_count: 1,
    movement_amplitude: 'auto',
    schedule_mode: 'normal',
  },
  settingsQ3_a: {
    duration: 5,
    resolution: '720p',
    movement_amplitude: 'auto',
    aspect_ratio: '16:9',
    sample_count: 1,
    schedule_mode: 'normal',
  },
  settingsQ3_hh: {
    duration: 5,
    resolution: '720p',
    movement_amplitude: 'auto',
    aspect_ratio: '16:9',
    sample_count: 1,
    schedule_mode: 'normal',
  },
};

/** 参考生默认表单；Q3 生成模式默认「营销广告」 */
export const DEFAULT_CHARACTER2VIDEO_FORM_PARAMS: FormParams = {
  ...DEFAULT_FORM_PARAMS,
  settingsQ3: {
    ...DEFAULT_FORM_PARAMS.settingsQ3,
    transition: TASK_TRANSITION_PRO_AD,
  },
};

export const DEFAULT_IMAGE_FORM_PARAMS: FormParams = {
  ...DEFAULT_FORM_PARAMS,
  modelVersion: MODEL_VERSION.GPT_IMAGE_2_5_FAST,
  settingsQ2: {
    ...DEFAULT_FORM_PARAMS.settingsQ2,
    aspect_ratio: 'intelligent',
    duration: 0,
  },
};
